import { Component } from '@angular/core';
import { Title }     from '@angular/platform-browser';

// import './modal.less';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public constructor(private titleService: Title ) { }

  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
  title = 'Tagesfahrten';
  ngOnInit() {
    this.setTitle('Funk');
  }
}
